/** Pure keep-set diff for IndexedDB prune. Does not read record bodies. */
export function stalePrimaryKeys(localKeys, keepIds) {
  const stale = [];
  const list = Array.isArray(localKeys) ? localKeys : [];
  for (let i = 0; i < list.length; i += 1) {
    const id = list[i];
    if (keepIds.has(id) || keepIds.has(String(id))) continue;
    stale.push(id);
  }
  return stale;
}
